import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import LanguageSelector from '@/components/LanguageSelector';

export default function PrivacyPage() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-navy-950">
      <nav className="fixed top-0 w-full z-50 backdrop-blur-lg border-b border-white/5 bg-navy-950/80">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="https://customer-assets.emergentagent.com/job_7d9bc2e5-ff38-4e06-b101-9f0eb41c2616/artifacts/w350as9h_LOGOvrn-02.png" alt="VerbNotes" className="h-12" />
          </Link>
          <LanguageSelector variant="ghost" />
        </div>
      </nav>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-3xl mx-auto px-6 pt-28 pb-16"
      >
        <Link to="/" className="inline-flex items-center gap-2 text-cyan hover:text-cyan-300 mb-8 text-sm" data-testid="back-home-link">
          <ArrowLeft size={16} /> {t('contact_back')}
        </Link>

        <h1 className="font-heading text-4xl text-white mb-2" data-testid="privacy-title">{t('privacy_title')}</h1>
        <p className="text-slate-500 text-sm mb-10">{t('privacy_last_updated')}: February 14, 2026</p>

        <div className="prose-custom space-y-8 text-slate-300 leading-relaxed">
          <section>
            <p>{t('privacy_intro')}</p>
          </section>
          <section>
            <h2 className="text-xl text-white font-medium mb-3">{t('privacy_collect_title')}</h2>
            <p>{t('privacy_collect_desc')}</p>
          </section>
          <section>
            <h2 className="text-xl text-white font-medium mb-3">{t('privacy_use_title')}</h2>
            <p>{t('privacy_use_desc')}</p>
          </section>
          <section>
            <h2 className="text-xl text-white font-medium mb-3">{t('privacy_security_title')}</h2>
            <p>{t('privacy_security_desc')}</p>
          </section>
          <section>
            <h2 className="text-xl text-white font-medium mb-3">{t('privacy_rights_title')}</h2>
            <p>{t('privacy_rights_desc')}</p>
          </section>
          <section>
            <h2 className="text-xl text-white font-medium mb-3">{t('privacy_cookies_title')}</h2>
            <p>{t('privacy_cookies_desc')}</p>
          </section>
          <section>
            <h2 className="text-xl text-white font-medium mb-3">{t('privacy_contact_title')}</h2>
            <p>{t('privacy_contact_desc')}</p>
            <div className="mt-3 bg-navy-900/50 rounded-xl p-4 border border-white/5 text-slate-400">
              <p className="text-white font-medium">{t('contact_company')}</p>
              <p>Email: privacy@verbnotes.com</p>
            </div>
          </section>
        </div>
      </motion.div>

      <footer className="border-t border-white/5 py-6 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-slate-500 text-sm">&copy; 2026 VerbNotes. {t('contact_company')}.</p>
        </div>
      </footer>
    </div>
  );
}
